// extracted by mini-css-extract-plugin
export default {"button":"RemoveFieldButton_button__di0pX","floating":"RemoveFieldButton_floating__g--wO"};